import request from '@src/api/request';
import { RequestConfig } from '@src/types/common.type';

import { CommResult, ModuleSubmitContactUsReq, ModuleSubmitContactUsRsp } from './data-contracts';

/**
 * No description
 *
 * @tags ContactUsAPI
 * @name SubmitCreate
 * @summary 提交留资信息
 * @request POST:/contact_us/submit
 */
export const postContactUsSubmit = (
  data: ModuleSubmitContactUsReq,
  params: RequestConfig = {},
): Promise<
  CommResult & {
    data: ModuleSubmitContactUsRsp;
  }
> => request.post('/contact_us/submit', data, params);
